import isDebug from '../isDebug/isDebug';
/**
 * Log information to a browser's developer console ONLY when window.isDebug
 * is set to true.  The code that controls logging is hard-coded into the
 * various .ejs template files used by the app_express website.
 *
 * This helper is only guaranteed to work on app_express because the code for
 * window.log is part of the HTML template for the Express website.
 *
 * TODO: we should make this not dependant on app_express templates.  Could
 * set up the core loog-ing code here instead.
 */
export default function loog(
  /** A message that will get logged to the browser console. */
  msg: string = '',
  /** The console.log method to use when logging to the browser console. The options for "status" come directly from the code that is inserted into the HTML template for app_express. */
  status: 'error' | 'info' | 'trace' | '' = 'info',
  /** Any additional data that you want to log with this message. */
  data: unknown = undefined
): void {
  if (isDebug()) {
    if (
      msg !== '' &&
      status !== '' &&
      window.log !== null &&
      window.log[status] !== undefined
    ) {
      if (data !== undefined) window.log[status](msg, data);
      else window.log[status](msg);
    }
  }
}
